import { jsx as _jsx } from "react/jsx-runtime";
import trillionOrangeUrl from '../../../assets/gems/trillion_orange.svg?inline';
export function TrillionOrange({ ...props }) {
    return _jsx("img", { ...props, src: trillionOrangeUrl, alt: 'TrillionOrangeImage' });
}
